



























import { Component, Vue, Mixins } from 'vue-property-decorator';
import LuxtagMixin from '@/assets/ts/luxtagMixin.ts';
import { EventBus } from '@/plugins/event-bus';

@Component
export default class Home extends Mixins(LuxtagMixin) {
    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            // access to component instance via `vm`
            EventBus.$emit('change-hide-slider', true);
            EventBus.$emit('change-show-tab-active-color', false);
        });
    }

    public beforeRouteLeave(to: any, from: any, next: any) {
        EventBus.$emit('change-hide-slider', false);
        EventBus.$emit('change-show-tab-active-color', true);
        next();
    }
}
